module.exports = "/_next/static/images/alaska-887f293166d025bca7f8a6f4be9a8207.svg";